import { CircularLoader, ErrorPageLayout } from '../../../presentation';
import {
  StatusTypeEnum,
  TargetAreaType,
  useShouldPoll,
  useStatusesQuery,
} from '@converge/graphql';
import { useParams } from 'react-router-dom';
import { StatusesList } from '../../submission/submission-status-badge';
import { SortOrder } from '@converge/data';
import { useEffect } from 'react';

interface IUnderwritingOverviewDataCollectionSection {
  updateStatus:
    | {
        __typename?: 'SubscriptionNoticeDetails' | undefined;
        noticeType?: string | null | undefined;
        noticeArea?: string | null | undefined;
        noticeTask?: string | null | undefined;
        noticeName?: string | null | undefined;
        noticeValue?: string | null | undefined;
        noticeDagId?: string | null | undefined;
      }
    | null
    | undefined;
}

export const UnderwritingOverviewDataCollectionSection = (
  props: IUnderwritingOverviewDataCollectionSection
) => {
  const { submissionUuid } = useParams<'submissionUuid'>();
  const { updateStatus } = props;
  const { poll } = useShouldPoll();

  const { info, data, loading, error, refetch } = useStatusesQuery({
    operationName: 'overviewDataCollectionSection',
    sort: SortOrder.Asc,
    filters: {
      targetUuid: submissionUuid,
      targetArea: TargetAreaType.Submission,
      details: false,
      statusType: StatusTypeEnum.DataCollection,
    },
  });

  useEffect(() => {
    if (
      (updateStatus !== null || updateStatus !== undefined) &&
      updateStatus?.noticeType === 'DATA_COLLECTION' &&
      updateStatus.noticeValue === 'completed'
    ) {
      refetch();
    }
  }, [updateStatus, refetch]);

  if (loading && !data) {
    return (
      <CircularLoader flexGrow={1} padding={5} style={{ color: ' #28c0a7' }} />
    );
  }

  if (error) {
    return (
      <ErrorPageLayout
        message={error.message}
        messageId="underwriting.overview.data-collection.section.error"
      />
    );
  }

  return (
    <div>
      <StatusesList statuses={info.statuses} poll={poll} showDagIdColumn />
    </div>
  );
};
